module.exports = __webpack_public_path__ + "static/media/turmasSeta.c35107e3.png";